<template>
  <div class="i-report-hero">
    <img
      :src="ReportHero"
      alt="Report Hero"
    />
    <div class="container">
      <h1 class="heading">{{ text }}</h1>
    </div>
  </div>
</template>

<script setup lang="ts">
import ReportHero from "@/assets/heros/report-hero.svg"

defineProps({
  text: {
    type: String,
    default: "Your Results"
  }
})
</script>

<style scoped lang="scss">
.i-report-hero {
  padding: 0;
  text-align: center;
  overflow: hidden;
  position: relative;

  img {
    position: relative;
    width: 1440px;
    height: 422px;
    object-fit: cover;
    object-position: 70% center;

    @media screen and (min-width: $breakpoint-lg) {
      object-position: center;
    }

    @media screen and (min-width: $breakpoint-xxl) {
      width: 100%;
      height: auto;
    }
  }

  .container {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;

    @media screen and (min-width: $breakpoint-md) {
      bottom: 50%;
    }

    .heading {
      @include display-lg;

      font-weight: 700;
      color: $black;
      z-index: 1;
      max-width: 720px;
      width: 100%;
      margin: 0 24px;
      text-align: start;

      @media screen and (min-width: $breakpoint-md) {
        margin: 0 auto;
      }

      @media screen and (min-width: $breakpoint-lg) {
        max-width: 988px;
      }

      @media screen and (min-width: $breakpoint-xl) {
        max-width: 720px;
        margin-left: 364px;
      }

      @media screen and (min-width: $breakpoint-xxl) {
        margin: 0 auto;
      }
    }
  }
}

@media print {
  .i-report-hero {
    display: none;
  }
}
</style>
